import { render, staticRenderFns } from "./GlobalSideNavBar.vue?vue&type=template&id=2ed0b5a8&scoped=true&"
import script from "./GlobalSideNavBar.vue?vue&type=script&lang=js&"
export * from "./GlobalSideNavBar.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSideNavBar.vue?vue&type=style&index=0&id=2ed0b5a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed0b5a8",
  null
  
)

export default component.exports